<template>

  <div class="app-form" :class="stilestruttura">
    <input type="hidden" name="g_token" v-if="recaptcha" value="">
    <template class="" v-for="(value, key) in label">

      <div :data-field="key" v-if="!value[8] || value[8] !== 'onFileUpload' || hasAnyUploadedFilesComputed">

        <!-- split due o piu form -->
        <div v-if="(value[1] === 'split')">
        </div>

        <!-- input text -->
        <div v-if="(value[1] === 'text' || value[1] === 'email') ">

          <div class="flex flex-col gap-2 w-full">
            <label v-if="shouldShowFieldLabel(value)" :for="key" class="text-sm font-semibold label-form">
              {{ value[0] }} <span v-if="isFieldRequired(key)">*</span>
            </label>

            <InputText v-model="info[key]" class="form-input w-full" :type="value[1]"
                       :invalid="errors !== undefined && key in errors" :name="key"
                       :placeholder="getTextFieldPlaceholder(value)"/>
          </div>

          <div v-if="typeof value[4] !== 'undefined' && value[4] !== '' && info[key] !== ''">
          <span v-if="info[key] !== ''" @click="check(value[4] , info[key] , key)" style="cursor: pointer"
                class="flex mt-1">
            <i class="pi pi-question-circle"/> {{$root.trans.controlla_l_unicita_del}} {{ value[0] }}
          </span>
          </div>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">{{ errors[key] }}</Message>
        </div>

        <!-- input text on change -->
        <div v-if="(value[1] === 'text-on-change' || value[1] === 'email-on-change') ">

          <div class="flex flex-col gap-2 w-full">
            <label v-if="shouldShowFieldLabel(value)" :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired(key)">*</span></label>
            <InputText v-model="info[key]" class="form-input w-full" :type="value[1]"
                       :invalid="errors !== undefined && key in errors" :name="key"
                       :placeholder="getTextFieldPlaceholder(value)"
                       @change="(event)=>onChangeText(event, key)"/>
          </div>

          <div v-if="typeof value[4] !== 'undefined' && value[4] !== '' && info[key] !== ''">
          <span v-if="info[key] !== ''" @click="check(value[4] , info[key] , key)" style="cursor: pointer"
                class="flex mt-1">
            <i class="pi pi-question-circle"/> {{$root.trans.controlla_l_unicita_del}} {{ value[0] }}
          </span>
          </div>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">{{ errors[key] }}</Message>
        </div>

        <!-- password -->
        <div v-if="value[1] === 'password'" class="mb-4">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span>*</span></label>
            <Password id="password" :name="key" toggleMask
                      :feedback="key !== 'password_vecchia'"
                      :invalid="errors !== undefined && key in errors"
                      v-model="info[key]" required inputClass="form-input w-full"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Editor -->
        <div class="col-span-3" v-if="value[1] === 'textarea'">
          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">
              {{ value[0] }} <span v-if="isFieldRequired[key]">*</span>
            </label>
            <Editor :name="key" v-model="info[key]"
                    :invalid="errors !== undefined && key in errors" pt:image:class="!hidden">
              {{ info[key] }}
            </Editor>
          </div>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- AI Editor -->
        <div class="col-span-3" v-if="value[1] === 'textarea-ai'">
          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">
              {{ value[0] }} <span v-if="isFieldRequired[key]">*</span>
            </label>
            <Editor :name="key" v-model="info[key]"
                    :invalid="errors !== undefined && key in errors" pt:image:class="!hidden"
                    pt:toolbar:class="relative flex flex-wrap items-center gap-x-2 gap-y-2 pr-12">
              <template #toolbar>
                <div class="ql-tools flex flex-wrap items-center gap-x-2 gap-y-2 grow">
                  <!-- Heading -->
                  <span class="ql-formats">
                    <select class="ql-header">
                      <option selected></option>
                      <option value="1"></option>
                      <option value="2"></option>
                      <option value="3"></option>
                    </select>
                  </span>
                  <!-- Font -->
                  <span class="ql-formats">
                    <select class="ql-font"></select>
                  </span>
                  <!-- Color & Background -->
                  <span class="ql-formats">
                    <select class="ql-color"></select>
                    <select class="ql-background"></select>
                  </span>
                  <!-- List -->
                  <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                  </span>
                  <!-- Align -->
                  <span class="ql-formats">
                    <select class="ql-align"></select>
                  </span>
                  <!-- Link -->
                  <span class="ql-formats">
                    <button class="ql-link"></button>
                  </span>
                  <!-- Code Block -->
                  <span class="ql-formats">
                    <button class="ql-code-block"></button>
                  </span>
                </div>
                <!-- AI pinned right -->
                <span class="ql-formats absolute right-2 top-2">
                  <button class="ql-ai-fix" @click="$emit('aiHelp', { event: $event, key, value: info[key] })">
                    <img style="width: 18px" src="/img-appalto/fix-with-ai.svg"/>
                  </button>
                </span>
              </template>
              {{ info[key] }}
            </Editor>
          </div>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Editor ReadOnly -->
        <div v-if="value[1] === 'textarea-readonly'">
          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">
              {{ value[0] }} <span v-if="isFieldRequired[key]">*</span>
            </label>
            <Editor v-model="info[key]" editorStyle="height: 320px" readonly :name="key"/>
          </div>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Color Picker -->
        <div v-if="value[1] === 'color'">

          <div class="flex flex-col gap-2 w-full">
            <label class="text-sm font-semibold label-form">{{ value[0] }} <span
                v-if="value[2].includes('required')">*</span></label>
            <ColorPicker v-model="info[key]" class="form-input w-full" :type="value[1]" :name="key"
                         :invalid="errors !== undefined && key in errors"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- readonly -->
        <div v-if="(value[1] === 'readonly') ">

          <div class="flex flex-col gap-2 w-full">
            <label class="text-sm font-semibold label-form">{{ value[0] }} <span
                v-if="value[2].includes('required')">*</span></label>
            <InputText v-model="info[key]" class="form-input w-full" :type="value[1]" :name="key" readonly/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Date Time picker -->
        <div v-if="value[1] === 'date'">

          <div class="flex flex-col gap-2 w-full">
            <label class="text-sm font-semibold label-form">{{ value[0] }} <span
                v-if="value[2].includes('required')">*</span></label>
            <DatePicker v-model="info[key]" showIcon fluid :showOnFocus="false" dateFormat="dd-mm-yy"
                        :name="key" :invalid="errors  !== undefined && key in errors" :locale="$root.trans"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <div v-if="value[1] === 'time'">

          <div class="flex flex-col gap-2 w-full">
            <label class="text-sm font-semibold label-form">{{ value[0] }} <span
                v-if="value[2].includes('required')">*</span></label>
            <DatePicker v-model="info[key]" timeOnly showIcon fluid :showOnFocus="false" dateFormat="hh:mm"
                        :name="key" :invalid="errors !== undefined && key in errors" :locale="$root.trans"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <div v-if="value[1] === 'date-range'">

          <div class="flex flex-col gap-2 w-full">
            <label class="text-sm font-semibold label-form">{{ value[0] }} <span
                v-if="value[2].includes('required')">*</span></label>
            <div class="relative">
              <DatePicker v-model="info[key]"
                          showIcon
                          fluid
                          selectionMode="range"
                          dateFormat="dd/mm/yy"
                          :manualInput="false"
                          :name="key"
                          :numberOfMonths="2"
                          :hideOnRangeSelection="dateRangeAutoClose"
                          :invalid="errors !== undefined && key in errors"
                          :locale="$root.trans"
                          @update:modelValue="(value) => onChangeDateRange(value, key)"
              />
              <button
                  v-if="dateRangeClearable"
                  type="button"
                  class="p-button p-component p-button-text p-button-rounded absolute right-2 top-1/2 -translate-y-1/2"
                  aria-label="Pulisci date"
                  @click="clearDateRange(key)"
              >
                <i class="pi pi-times"></i>
              </button>
            </div>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <div v-if="value[1] === 'datetime'">

          <div class="flex flex-col gap-2 w-full">
            <label class="text-sm font-semibold label-form">{{ value[0] }} <span
                v-if="value[2].includes('required')">*</span></label>
            <DatePicker v-model="info[key]" showTime hourFormat="24"
                        :name="key" fluid :invalid="errors !== undefined && key in errors" :locale="$root.trans"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <div v-if="value[1] === 'datetime-range'">

          <div class="flex flex-col gap-2 w-full">
            <label class="text-sm font-semibold label-form">{{ value[0] }} <span
                v-if="value[2].includes('required')">*</span></label>
            <DatePicker v-model="info[key]" showTime hourFormat="24" :name="key" fluid selectionMode="range"
                        :manualInput="false" :numberOfMonths="2" :invalid="errors !== undefined && key in errors"
                        :locale="$root.trans"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <div v-if="value[1] === 'month'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span
                v-if="value[2].includes('required')">*</span></label>
            <DatePicker v-model="info[key]" view="month" dateFormat="mm-yy" :name="key" fluid
                        :invalid="errors !== undefined && key in errors" :locale="$root.trans"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <div v-if="value[1] === 'daymonth'">

          <div class="flex flex-col gap-2 w-full">
            <label class="text-sm font-semibold label-form">{{ value[0] }} <span
                v-if="value[2].includes('required')">*</span></label>
            <DatePicker v-model="info[key]" showIcon fluid :showOnFocus="false" dateFormat="dd-mm"
                        :name="key" :invalid="errors !== undefined && key in errors" :locale="$root.trans"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <div v-if="value[1] === 'year'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }}<span
                v-if="value[2].includes('required')">*</span></label>
            <DatePicker v-model="info[key]" view="year" dateFormat="yy" :name="key" fluid
                        :invalid="errors !== undefined && key in errors" :locale="$root.trans"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Hidden -->
        <template v-if="value[1] === 'hidden'" style="display: none !important;">
          <input v-model="info[key]" type="hidden" :name="key">
        </template>

        <!-- File Upload - MAX 20MB -->
        <div v-if="value[1] === 'file'" :id="'id_'+key">
          <div class="flex flex-col gap-2 w-full">
            <label class="text-sm font-semibold label-form">
              {{ value[0] }} <span v-if="isFieldRequired[key]">*</span>
            </label>
            <div class="file-upload-container"
                 @dragover.prevent="onDragOver($event, key)"
                 @dragleave.prevent="onDragLeave($event, key)"
                 @drop.prevent="onDrop($event, key, value[4], value[3])">
              <FileUpload :key="getFileUploadKey(key)"
                          :name="key"
                          :multiple="value[4]"
                          @select="(event) => onFileSelect(event, key, value[4])"
                          :accept="value[3]"
                          :maxFileSize="20000000"
                          :auto="false"
                          :showUploadButton="false"
                          :showCancelButton="false"
                          :ref="'fileupload_' + key">
                <template #header="{chooseCallback}">
                  <div class="file-upload-actions">
                    <div class="file-selector-box-wrapper">
                      <Button
                          @click=chooseCallback
                          class="box-file-selector"
                          :unstyled="true"
                      ><i class="pi pi-plus"></i>
                        <span class="box-file-selector-text">{{ $root.trans.allega_file }}</span>
                      </Button>
                    </div>
                    <div v-if="getFilesByKey(key).length > 3" class="collapse-toggle-container">
                      <Button
                          @click="toggleCollapse(key)"
                          class="collapse-toggle-btn"
                          :unstyled="true"
                      >
                        <i :class="isFileExpanded(key) ? 'pi pi-angle-double-up' : 'pi pi-angle-double-down'"></i>
                        <span class="box-file-selector-text">{{ $root.trans.visualizza_tutti }}</span>
                      </Button>
                    </div>
                  </div>
                  <div class="uploaded-file-container">
                    <ul class="uploaded-file-list">
                      <template v-for="(file, index) of getFilesByKey(key).slice(0, 3)"
                                :key="file.name + file.type + file.size">
                        <li>
                          <div class="uploaded-file-info">
                            <div class="file-upload-icon-container" @click="removeFileFromList(files, index, key)">
                              <div class="tail-up-container">
                                <div class="tail-up-button">
                                  <p>{{ $root.trans.elimina }}</p>
                                </div>
                                <div class="tail-up"></div>
                              </div>
                              <i class="pi pi-paperclip default-icon"></i>
                              <i class="pi pi-times hover-icon"></i>
                            </div>
                            <div class="file-upload-name-container">
                              <span class="file-upload-name" @click="openFile(file)">{{ file.name }}</span>
                              <div class="tail-container">
                                <div class="tail"></div>
                                <div class="tail-button">
                                  <p>{{ $root.trans.apri_allegato }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </template>
                      <div v-if="isFileExpanded(key)" class="additional-files">
                        <template v-for="(file, index) of getFilesByKey(key).slice(3)"
                                  :key="file.name + file.type + file.size + '_additional'">
                          <li>
                            <div class="uploaded-file-info">
                              <div class="file-upload-icon-container"
                                   @click="removeFileFromList(files, index + 3, key)">
                                <div class="tail-up-container">
                                  <div class="tail-up-button">
                                    <p>{{ $root.trans.elimina }}</p>
                                  </div>
                                  <div class="tail-up"></div>
                                </div>
                                <i class="pi pi-paperclip default-icon"></i>
                                <i class="pi pi-times hover-icon"></i>
                              </div>
                              <div class="file-upload-name-container">
                                <span class="file-upload-name" @click="openFile(file)">{{ file.name }}</span>
                                <div class="tail-container">
                                  <div class="tail"></div>
                                  <div class="tail-button">
                                    <p>{{ $root.trans.apri_allegato }}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </template>
                      </div>
                    </ul>
                  </div>
                </template>
                <template #content>
                  <span></span>
                </template>
              </FileUpload>
            </div>
            <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
              {{ errors[key] }}
            </Message>
          </div>
        </div>

        <!-- Number -->
        <div v-if="value[1] === 'intero'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired[key]">*</span></label>
            <InputNumber v-model="info[key]" :name="key" inputId="integeronly" :minFractionDigits="0"
                         :maxFractionDigits="0"
                         fluid :invalid="errors !== undefined && key in errors"
                         inputClass="form-input"
            />
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <div v-if="value[1] === 'decimale'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired[key]">*</span></label>
            <InputNumber v-model="info[key]" :name="key" inputId="minmaxfraction" :minFractionDigits="2"
                         :maxFractionDigits="5"
                         fluid :invalid="errors !== undefined && key in errors"
                         inputClass="form-input"
            />
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <div v-if="value[1] === 'number'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired[key]">*</span></label>
            <InputNumber v-model="info[key]" :name="key" inputId="minmax-buttons" showButtons
                         :min="value[5]"
                         :step="value[3]" fluid :invalid="errors !== undefined && key in errors"
                         inputClass="form-input"
            />
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <div v-if="value[1] === 'numeratore'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired[key]">*</span></label>
            <InputNumber v-model="info[key]" :name="key" inputId="minmax-buttons" showButtons
                         :step="value[3]" :min="value[5]" :max="value[6]" fluid
                         :invalid="errors !== undefined && key in errors"
                         inputClass="form-input"
            />
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Radio -->
        <div v-if="value[1] === 'radio'">
          <div class="flex flex-col gap-2">
            <label class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired(key)">*</span></label>
            <div class="flex flex-row flex-wrap items-center gap-x-6 gap-y-2">
              <div v-for="opt in value[3]" :key="opt.id" class="flex items-center gap-2">
                <RadioButton v-model="info[key]" :inputId="`${key}-${opt.id}`" :name="key" :value="opt.id"/>
                <label :for="`${key}-${opt.id}`" class="cursor-pointer">{{ opt.nome }}</label>
              </div>
            </div>
          </div>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Checkbox -->
        <div v-if="value[1] === 'checkbox'">
          <div class="checkbox-row">
            <label :class="'form-label block text-black text-sm mb-2'+value[2]">{{ value[0] }} <span
                v-if="isFieldRequired[key]">*</span></label>
            <Checkbox v-model="info[key]" class="form-check-input" :name="key" binary
                      :invalid="errors !== undefined && key in errors"/>
          </div>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>
        <div v-if="value[1] === 'checkbox-on-change'">
          <label :class="'form-label block text-gray-700 text-sm mb-2'+value[2]">{{ value[0] }} <span
              v-if="isFieldRequired[key]">*</span></label>
          <div class="flex flex-col gap-2">
            <label v-for="(t, i) in value[3]" :key="i" class="flex items-center gap-3 cursor-pointer">
              <Checkbox v-model="info[key]" class="form-check-input" :name="key" :inputId="t.key || t.id" name="checkboxmulti[]"
                        :value="t.id" :invalid="errors !== undefined && key in errors" :readonly="t.readonly"
                        @change="(event)=> onChangeCheckbox(event,key)"/>
              <span class="form-check-label">{{ t.nome }}</span>
            </label>
          </div>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <div v-if="value[1] === 'checkbox-multipla'">
          <label :class="'form-label block text-gray-700 text-sm mb-2'+value[2]">{{ value[0] }} <span
              v-if="isFieldRequired[key]">*</span></label>
          <div class="flex flex-col gap-2">
            <label v-for="(t, i) in value[3]" :key="i" class="flex items-center gap-3 cursor-pointer">
              <Checkbox v-model="info[key]" class="form-check-input" :name="key" :inputId="t.key || t.id" name="checkboxmulti[]"
                        :value="t.id" :invalid="errors !== undefined && key in errors" :readonly="t.readonly"/>
              <span class="form-check-label">{{ t.nome }}</span>
            </label>
          </div>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Select multipla -->
        <div v-if="value[1] === 'select-multipla'">

          <div class="flex flex-col gap-2 w-full">
            <label class="text-sm font-semibold label-form">{{ value[0] }} <span
                v-if="isFieldRequired[key]">*</span></label>
            <MultiSelect v-model="info[key]" display="chip" :name="key" :options="value[3]" optionLabel="nome"
                         optionValue="id" filter
                         :placeholder="value[4]" class="form-input w-full"
                         :invalid="errors !== undefined && key in errors"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>
        <!-- Select multipla add -->
        <div v-if="value[1] === 'select-multipla-add'">

          <div class="flex flex-col gap-2 w-full">
            <label class="text-sm font-semibold label-form">{{ value[0] }} <span
                v-if="isFieldRequired[key]">*</span></label>
            <MultiSelect v-model="info[key]" display="chip" :name="key" :options="value[3]" optionLabel="nome"
                         optionValue="id" filter
                         :placeholder="value[4]" class="form-input w-full"
                         :invalid="errors !== undefined && key in errors">
              <template #footer>
                <div class="p-3">
                  <Button :label="$root.trans.aggiungi_nuovo" @click="showModal[key] = true"
                          fluid severity="secondary" text size="small" icon="pi pi-plus"/>
                </div>
              </template>
            </MultiSelect>
          </div>

          <Dialog v-model:visible="showModal[key]" modal :header="$root.trans.aggiungi+' '+value[0]"
                  :style="{ width: '25rem' }">
            <FormInput
                :dati="value[6]"
                :formlabel="value[5]"
                stilestruttura="grid grid-cols-1 md:grid-cols-1 gap-3"
                :action="value[7]"
                :ref="'modalinput_'+key">
            </FormInput>
            <a type="button" class="p-button p-component p-button-secondary"
               @click="showModal[key] = false">{{ $root.trans.annulla }}</a>
            <button @click="checkModale(key, true)" class="p-button p-component p-button-success">
              <span class="p-button-label">{{ $root.trans.aggiungi }}</span>
            </button>
          </Dialog>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Select classica -->
        <div v-if="value[1] === 'select'">
          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">
              {{ value[0] }} <span v-if="isFieldRequired(key)">*</span>
            </label>

            <Select v-model="info[key]" :options="value[3]" :name="key" optionLabel="nome" optionValue="id"
                    :placeholder="value[4]"
                    class="form-input w-full" :invalid="errors !== undefined && key in errors"/>
          </div>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Select con evento al cambiamento -->
        <div v-if="value[1] === 'select-on-change'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired[key]">*</span></label>
            <Select v-model="info[key]" :options="value[3]" :name="key" :filter="value[5]" optionLabel="nome"
                    optionValue="id"
                    :placeholder="value[4]"
                    class="form-input w-full" :invalid="errors !== undefined && key in errors"
                    @change="(event)=> onChangeSelect(event,key)"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>
        <!-- Select-multipla con evento al cambiamento -->
        <div v-if="value[1] === 'select-multipla-on-change'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired[key]">*</span></label>
            <MultiSelect v-model="info[key]" display="chip" :name="key" :options="value[3]" optionLabel="nome"
                         optionValue="id" filter
                         :placeholder="value[4]" class="form-input w-full"
                         :invalid="errors !== undefined && key in errors"
                         @change="(event)=> onChangeSelectMultiple(event,key)"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- select  con ricerca -->
        <div v-if="value[1] === 'select-filter'">
          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">
              {{ value[0] }} <span v-if="isFieldRequired(key)">*</span>
            </label>
            <Select
                v-model="info[key]" filter :options="value[3]" :name="key" optionLabel="nome" optionValue="id"
                class="form-input w-full " :invalid="errors !== undefined && key in errors"
            />
          </div>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Select con gruppi -->
        <div v-if="value[1] === 'select-group'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired[key]">*</span></label>
            <Select v-model="info[key]" :options="value[3]" :name="key" optionLabel="nome" optionValue="id"
                    :placeholder="value[4]"
                    optionGroupLabel="label" optionGroupChildren="items"
                    class="form-input w-full" :invalid="errors !== undefined && key in errors"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- select aggiungi tramite modale -->
        <div v-if="value[1] === 'select-add'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired(key)">*</span></label>
            <Select v-model="info[key]"
                    :options="value[3]"
                    :name="key"
                    optionLabel="nome"
                    optionValue="id"
                    :placeholder="value[4]"
                    class="form-input w-full"
                    :invalid="errors !== undefined && key in errors">
              <template #footer>
                <div class="p-3">
                  <Button :label="$root.trans.aggiungi_nuovo" @click="showModal[key] = true"
                          fluid severity="secondary" text size="small" icon="pi pi-plus"/>
                </div>
              </template>
            </Select>
          </div>

          <Dialog v-model:visible="showModal[key]" modal :header="$root.trans.aggiungi+' '+value[0]"
                  :style="{ width: '25rem' }">
            <FormInput
                :dati="value[6]"
                :formlabel="value[5]"
                stilestruttura="grid grid-cols-1 md:grid-cols-1 gap-3"
                :action="value[7]"
                :ref="'modalinput_'+key">
            </FormInput>
            <a type="button" class="p-button p-component p-button-secondary"
               @click="showModal[key] = false">{{ $root.trans.annulla }}</a>
            <button @click="checkModale(key)" class="p-button p-component p-button-success">
              <span class="p-button-label">{{ $root.trans.aggiungi }}</span>
            </button>
          </Dialog>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- select aggiungi tramite modale -->
        <div v-if="value[1] === 'tree-select'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired[key]">*</span></label>
            <TreeSelect v-model="info[key]"
                        filter filterMode="strict"
                        :name="key"
                        optionLabel="label"
                        optionValue="key"
                        selectionMode="single"
                        :options="value[3]"
                        :placeholder="value[4]"
                        class="form-input w-full"
                        :invalid="errors !== undefined && key in errors">
            </TreeSelect>
          </div>

        </div>

        <!-- toggle switch -->
        <div v-if="value[1] === 'toggle'" class="flex items-center gap-3">
          <ToggleSwitch
              v-model="info[key]"
              :id="key"
              :binary="true"
              :invalid="errors !== undefined && key in errors"
              :pt="{
              slider: {
                class: info[key] ? '!bg-blue-500' : ''
              }
            }"
          />
          <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span
              v-if="isFieldRequired[key]">*</span></label>
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- datatable editabile -->
        <div v-if="value[1] === 'datatable'" class="col-span-3">
          <label :for="key">{{ value[0] }} <span v-if="isFieldRequired[key]">*</span></label>
          <DatatableForm
              :modulo="value[3]"
              :colonne="value['colonne']"
              :route_righe="value['route_righe']"
              :mess_vuoto="$root.trans.nessun_dato"
              :mess_caricamento="$root.trans.caricamento"
              :route_params="value['route_params']"
              :ref="'datatable_' + key"
              @data-updated="(rows, sums) => updateDatatableData(key, rows, sums)"
          />
          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Datatable Sum - Campo somma disabilitato -->
        <div v-if="value[1] === 'datatable-sum'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }}</label>
            <InputText v-model="info[key]" class="form-input w-full" type="text" :name="key" readonly disabled/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Autocomplete -->
        <div v-if="value[1] === 'autocomplete'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired[key]">*</span></label>
            <AutoComplete v-model="info[key]" :suggestions="value[3]" @complete="(e)=>search(e,key, value)"
                          :name="key" :invalid="errors !== undefined && key in errors" class="form-input w-full"
                          inputClass="w-full"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>
        <!-- Autocomplete on change -->
        <div v-if="value[1] === 'autocomplete-on-change'">

          <div class="flex flex-col gap-2 w-full">
            <label :for="key" class="text-sm font-semibold label-form">{{ value[0] }} <span v-if="isFieldRequired[key]">*</span></label>
            <AutoComplete v-model="info[key]" :suggestions="value[3]" @complete="(e)=>search(e,key, value)"
                          @value-change="(e)=> onChangeSelect(e,key)"
                          :name="key" :invalid="errors !== undefined && key in errors" class="form-input w-full"
                          inputClass="w-full"/>
          </div>

          <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
            {{ errors[key] }}
          </Message>
        </div>

        <!-- Rating -->
        <div v-if="value[1] === 'rating'">
          <label :for="key">{{ value[0] }} <span v-if="isFieldRequired[key]">*</span></label>
          <Rating v-model="info[key]" :name="key" @change="(event)=>onRatingChange(event, key)"></Rating>
        </div>

      </div>
    </template>
  </div>
</template>

<script>
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import ColorPicker from 'primevue/colorpicker';
import Editor from 'primevue/editor';
import DatePicker from 'primevue/datepicker';
import FileUpload from 'primevue/fileupload';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import MultiSelect from 'primevue/multiselect';
import Select from 'primevue/select';
import TreeSelect from 'primevue/treeselect';
import AutoComplete from 'primevue/autocomplete';
import FloatLabel from 'primevue/floatlabel';
import Message from 'primevue/message';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import RadioButton from 'primevue/radiobutton';
import ToggleSwitch from 'primevue/toggleswitch';
import DatatableForm from "./DatatableForm.vue";
import Rating from './Rating.vue';

export default {
  name: "FormInput",
  components: {
    InputText,
    Password,
    ColorPicker,
    Editor,
    DatePicker,
    FileUpload,
    InputNumber,
    Checkbox,
    RadioButton,
    MultiSelect,
    Select,
    TreeSelect,
    AutoComplete,
    FloatLabel,
    Message,
    Button,
    Dialog,
    ToggleSwitch,
    Rating,
    DatatableForm
  },
  props: ['dati', 'file_key', 'formlabel', 'stilestruttura', 'clone', 'idform', 'action', 'recaptcha', 'dateRangeClearable', 'dateRangeAutoClose'],
  emits: ['selectChanged', 'checkboxChanged', 'textChanged', 'aiHelp', 'dateRangeChanged'],
  data() {
    return {
      style: this.stilestruttura,
      info: this.dati,
      label: this.formlabel,
      errors: [],
      showModal: [],
      file_key: this.file_key,
      files: [], // Manteniamo per compatibilità
      expandedFiles: {},
      isDragOver: false,
      fileskey: {}, // Oggetto che contiene i file per ogni chiave
      filesToDelete: {}, // File da eliminare dal database
      fileUploadKeys: {}, // Chiavi per forzare la ricreazione dei componenti FileUpload
      isSubmitting: false,
    };
  },
  async created() {
    var vm = this;
    if (typeof vm.info == 'string') {
      vm.info = JSON.parse(vm.info)
    }
    if (typeof vm.label == 'string') {
      vm.label = JSON.parse(vm.label)
    }

    // Inizializza i campi datatable-sum con valore 0
    this.initializeDatatableSumFields();

    this.collectDatatableData();

    // trasforma in istanza d Date() i valori passati agli input date-range
    this.formatDateRangeFieldDates();
  },
  mounted() {
    var vm = this;
    document.dispatchEvent(new Event('vueMounted'));
    console.log(vm.info);
    console.log(vm.label);
    if (vm.label) {
      this.$nextTick(() => {
        setTimeout(() => {
          for (const [key, value] of Object.entries(vm.label)) {
            if (value[1] === 'select-on-change') {
              const event = {
                value: vm.info[key],
                originalEvent: null
              };
              vm.onChangeSelect(event, key);
            }
          }
          // Forza l'aggiornamento delle somme dei datatable dopo che tutti i componenti sono montati
          vm.collectDatatableData();
        }, 500);
      });
    }

  },
  watch: {
    // Osserva i cambiamenti nei dati info per aggiornare le somme automaticamente
    info: {
      handler(newInfo, oldInfo) {
        // Controlla se sono cambiati i dati delle somme dei datatable
        for (const key in newInfo) {
          if (key.endsWith('_sums') && newInfo[key] !== oldInfo[key]) {
            // Forza il re-render dei campi datatable-sum
            this.$forceUpdate();
            break;
          }
        }
      },
      deep: true
    }
  },
  computed: {
    requiredSelectGroups() {
      const groups = {};
      for (const [key, value] of Object.entries(this.label)) {
        if (value[2] && value[2].includes('requiredselect')) {
          if (!groups['requiredselect']) {
            groups['requiredselect'] = [];
          }
          groups['requiredselect'].push(key);
        }
      }
      return groups;
    },
    hasAnyUploadedFilesComputed() {
      for (const [key, value] of Object.entries(this.label)) {
        if (value[1] === 'file' && this.info[key] && Array.isArray(this.info[key]) && this.info[key].length > 0) {
          return true;
        }
      }
      return false;
    },
    isFieldRequired() {
      return (key) => {
        const fieldConfig = this.label[key];
        if (!fieldConfig) return false;

        const hasOnFileUploadFlag = fieldConfig[2] === 'onFileUpload';
        const originalValidation = fieldConfig[2];

        if (hasOnFileUploadFlag) {
          return this.hasAnyUploadedFilesComputed;
        } else if (originalValidation && originalValidation.includes('requiredselect')) {
          return this.isRequiredSelectGroupEmpty();
        } else {
          return originalValidation === 'required' || (originalValidation && originalValidation.includes('required'));
        }
      };
    },
    isRequiredSelectGroupEmpty() {
      if (!this.requiredSelectGroups.requiredselect) return false;
      return this.requiredSelectGroups.requiredselect.every(key => {
        const value = this.info[key];
        return !value || value.length === 0 || (Array.isArray(value) && value.length === 0);
      });
    },
    getFilesByKey() {
      return (key) => {
        return this.fileskey[key] || [];
      };
    },
    getFileUploadKey() {
      return (key) => {
        if (!this.fileUploadKeys[key]) {
          this.fileUploadKeys[key] = 0;
        }
        return `fileupload_${key}_${this.fileUploadKeys[key]}`;
      };
    }
  },
  methods: {
    getTextFieldPlaceholder(value) {
      return typeof value[5] === 'string' ? value[5] : undefined;
    },
    shouldShowFieldLabel(value) {
      return value[6] !== false;
    },
    formatDateRangeFieldDates() {
      for (const [key, value] of Object.entries(this.label)) {
        if (value[1] === 'date-range' && this.info[key]) {
          try {

            const dateRange = this.info[key];
            console.log(dateRange);
            if (Array.isArray(dateRange) && dateRange.length === 2) {
              this.info[key] = [
                dateRange[0] ? new Date(dateRange[0]) : null,
                dateRange[1] ? new Date(dateRange[1]) : null
              ];
              console.log(this.info[key])
            }
          } catch (e) {
            console.error(`Errore nel parsing del campo date-range per la chiave ${key}:`, e);
          }
        }
      }
    },
    updateDatatableData(fieldKey, datatableRows, columnSums) {
      this.info[fieldKey] = JSON.stringify(datatableRows);
      // Salva le somme delle colonne con una chiave specifica
      this.info[fieldKey + '_sums'] = JSON.stringify(columnSums || {});

      // Aggiorna i campi datatable-sum associati
      this.updateDatatableSumFields(fieldKey, columnSums || {});
    },
    updateDatatableSumFields(datatableKey, columnSums) {
      // Trova tutti i campi datatable-sum e aggiorna i loro valori in info[key]
      for (const [key, value] of Object.entries(this.label)) {
        if (value[1] === 'datatable-sum') {
          // Verifica se questo campo somma è associato al datatable che è stato aggiornato
          const baseKey = key.replace(/_sum$|_totale$|_somma$/, '');
          if (baseKey === datatableKey || this.isAssociatedDatatable(key, datatableKey)) {
            // Determina quale campo sommare
            let sumField = null;
            if (this.label[datatableKey] && this.label[datatableKey]['colonne']) {
              const numericColumn = this.label[datatableKey]['colonne'].find(col =>
                  col.editabile && col.formato === 'num_intero'
              );
              if (numericColumn) {
                sumField = numericColumn.name;
              }
            }

            // Aggiorna il valore del campo somma in info[key]
            const sumValue = columnSums[sumField] || columnSums.quantita || 0;
            this.info[key] = sumValue;
          }
        }
      }
    },
    isAssociatedDatatable(sumFieldKey, datatableKey) {
      // Se non c'è un datatable con nome simile, associa al primo datatable disponibile
      const baseKey = sumFieldKey.replace(/_sum$|_totale$|_somma$/, '');
      if (this.label[baseKey] && this.label[baseKey][1] === 'datatable') {
        return baseKey === datatableKey;
      }

      // Se non trova corrispondenza diretta, associa al primo datatable
      for (const [dtKey, dtValue] of Object.entries(this.label)) {
        if (dtValue[1] === 'datatable') {
          return dtKey === datatableKey;
        }
      }
      return false;
    },
    initializeDatatableSumFields() {
      // Inizializza tutti i campi datatable-sum con valore 0 se non hanno già un valore
      for (const [key, value] of Object.entries(this.label)) {
        if (value[1] === 'datatable-sum') {
          if (this.info[key] === undefined || this.info[key] === null || this.info[key] === '') {
            this.info[key] = 0;
          }
        }
      }
    },
    collectDatatableData() {
      for (const [key, value] of Object.entries(this.label)) {
        if (value[1] === 'datatable') {
          const datatableRef = this.$refs['datatable_' + key];
          if (datatableRef && datatableRef[0]) {
            this.info[key] = JSON.stringify(datatableRef[0].rows);
            const columnSums = datatableRef[0].calculateColumnSums();
            this.info[key + '_sums'] = JSON.stringify(columnSums);
            // Aggiorna anche i campi datatable-sum associati
            this.updateDatatableSumFields(key, columnSums);
          }
        }
      }
    },
    getDatatableSum(key) {
      // Trova il campo datatable corrispondente
      let datatableKey = null;
      let sumField = null;

      // Cerca il campo datatable associato a questo campo somma
      const currentField = this.label[key];
      if (currentField && currentField[1] === 'datatable-sum') {
        // Strategia 1: Cerca un datatable con nome simile (rimuovendo suffissi come '_sum', '_totale', etc.)
        const baseKey = key.replace(/_sum$|_totale$|_somma$/, '');
        if (this.label[baseKey] && this.label[baseKey][1] === 'datatable') {
          datatableKey = baseKey;
        }

        // Strategia 2: Se non trovato, cerca il primo datatable disponibile
        if (!datatableKey) {
          for (const [dtKey, dtValue] of Object.entries(this.label)) {
            if (dtValue[1] === 'datatable') {
              datatableKey = dtKey;
              break;
            }
          }
        }

        // Determina il campo da sommare
        if (datatableKey && this.label[datatableKey]['colonne']) {
          const numericColumn = this.label[datatableKey]['colonne'].find(col =>
              col.editabile && col.formato === 'num_intero'
          );
          if (numericColumn) {
            sumField = numericColumn.name;
          }
        }
      }

      if (datatableKey) {
        const datatableSumsKey = datatableKey + '_sums';
        if (this.info[datatableSumsKey]) {
          try {
            const sums = JSON.parse(this.info[datatableSumsKey]);
            // Se abbiamo identificato il campo specifico, usalo, altrimenti prova 'quantita' come fallback
            return sums[sumField] || sums.quantita || 0;
          } catch (e) {
            return 0;
          }
        }
      }
      return 0;
    },

    onFileSelect: function (event, key, isMultiple) {
      if (!isMultiple) {
        this.fileskey[key] = [event.files[event.files.length - 1]];
        this.info[key] = this.fileskey[key];
      } else {
        // Per file multipli, aggiungi ai file esistenti
        if (!this.fileskey[key]) {
          this.fileskey[key] = [];
        }

        // Trova solo i file veramente nuovi
        const existingFileNames = this.fileskey[key].map(f => f.name);
        const newFiles = event.files.filter(f => !existingFileNames.includes(f.name));

        this.fileskey[key].push(...newFiles);
        this.info[key] = this.fileskey[key];
      }
    },
    toggleCollapse(key) {
      this.expandedFiles[key] = !this.expandedFiles[key];
    },
    isFileExpanded(key) {
      return this.expandedFiles[key] || false;
    },
    onChangeCheckbox: function (event, key) {
      this.$emit('checkboxChanged', event, key);
      console.log('checkbox cambiata')
      document.dispatchEvent(new CustomEvent('checkboxChanged', {
        detail: {
          struttura: {...this.label},
          info: {...this.info},
          key: key
        }
      }));
    },
    onChangeText: function (event, key) {
      this.$emit('textChanged', event, key);
      console.log('text cambiata')
      document.dispatchEvent(new CustomEvent('textChanged', {
        detail: {
          struttura: {...this.label},
          info: {...this.info},
          key: key
        }
      }));
    },
    openFile(file) {
      if (file.isDbFile && file.url) {
        window.open(file.url, '_blank');
      } else {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');
        setTimeout(() => {
          URL.revokeObjectURL(fileURL);
        }, 1000);
      }
    },
    removeFileFromList(filesArray, indexToRemove, key) {
      if (this.fileskey[key] && indexToRemove >= 0 && indexToRemove < this.fileskey[key].length) {
        const fileToRemove = this.fileskey[key][indexToRemove];

        if (fileToRemove && fileToRemove.isDbFile) {
          if (!this.filesToDelete[key]) {
            this.filesToDelete[key] = [];
          }
          this.filesToDelete[key].push(fileToRemove.name);
        }

        this.fileskey[key].splice(indexToRemove, 1);
        this.info[key] = this.fileskey[key];

        // FORZA LA RICREAZIONE DEL COMPONENTE FileUpload
        this.fileUploadKeys[key] = (this.fileUploadKeys[key] || 0) + 1;

        this.$forceUpdate();
      }
    },

    onDragOver(event, key) {
      const container = event.currentTarget;
      container.classList.add('drag-over-container');
    },
    onDragLeave(event, key) {
      const container = event.currentTarget;
      if (!container.contains(event.relatedTarget)) {
        container.classList.remove('drag-over-container');
      }
    },
    onDrop(event, key, isMultiple, accept) {
      const container = event.currentTarget;
      container.classList.remove('drag-over-container');

      const droppedFiles = Array.from(event.dataTransfer.files);
      // Filtra per tipo accettato se specificato
      let validFiles = droppedFiles;
      if (accept) {
        const acceptTypes = accept.split(',').map(t => t.trim());
        validFiles = droppedFiles.filter(file => {
          return acceptTypes.some(type => {
            if (type.endsWith('/*')) {
              return file.type.startsWith(type.replace('/*', '/'));
            }
            return file.type === type || file.name.toLowerCase().endsWith(type);
          });
        });
      }
      // Filtra per dimensione massima (20MB)
      validFiles = validFiles.filter(f => f.size <= 20000000);

      if (validFiles.length === 0) return;

      // Simula l'evento onFileSelect
      this.onFileSelect({files: validFiles}, key, isMultiple);
    },
    onChangeSelect: function (event, key) {
      this.$emit('selectChanged', event, key);
      document.dispatchEvent(new CustomEvent('selectChanged', {
        detail: {
          struttura: {...this.label},
          info: {...this.info},
          key: key
        }
      }));

    },
    onChangeDateRange(value, key) {
      this.$emit('dateRangeChanged', {value, key});
      document.dispatchEvent(new CustomEvent('dateRangeChanged', {
        detail: {
          key: key,
          info: {...this.info},
          value: value
        }
      }));
    },
    clearDateRange(key) {
      this.info[key] = null;
      this.onChangeDateRange(this.info[key], key);
    },
    onRatingChange: function (value, key) {
      this.$emit('ratingChanged', value, key);

      document.dispatchEvent(new CustomEvent('ratingChanged', {
        detail: {
          key: key,
          info: {...this.info},
          struttura: {...this.label},
          rating: value
        }
      }));
    },
    search(e, key, value) {
      const soglia = value[5] || 0; // Default threshold if not provided
      if (e.query.length > soglia) {
        this.label[key][3] = value[4].filter((el) => {
          return el?.toLowerCase().includes(e.query.toLowerCase())
        });
      } else {
        return []
      }

    },
    check(rotta, valore, chiave) {
      axios.post(route(rotta), {
        valore: valore,
        id: this.info.id
      }).then((response) => {
        var errors = this.errors;
        var ris = response.data;
        if ("ko" in ris) {
          errors[chiave] = ris.ko;
          alert(ris['ko']);
        } else {
          delete errors[chiave]
          alert(ris['ok']);
        }

      })
    },
    inputValidation(chiave, chiave_confronto, validazione, tipo, label) {
      var b = false;
      var vm = this;


      if (validazione === "requiredselect") {
        const requiredSelectFields = [];
        for (const [key, value] of Object.entries(vm.label)) {
          if (value[2] && value[2].includes('requiredselect')) {
            requiredSelectFields.push(key);
          }
        }

        const hasAtLeastOneValue = requiredSelectFields.some(key => {
          const value = vm.info[key];
          return value && (!Array.isArray(value) || value.length > 0);
        });

        if (!hasAtLeastOneValue) {
          requiredSelectFields.forEach(key => {
            const fieldLabel = vm.label[key][0];
            vm.errors[key] = vm.$root.trans.almeno_un_campo_richiesto ||
                'Almeno uno dei campi deve essere selezionato';
          });
          b = true;
        } else {
          requiredSelectFields.forEach(key => {
            delete vm.errors[key];
          });
        }
      }

      if (validazione.includes("requiredselect") && validazione.includes("|")) {
        const validations = validazione.split("|");
        if (validations.includes("requiredselect")) {
          if (vm.inputValidation(chiave, chiave_confronto, "requiredselect", tipo, label)) {
            b = true;
          }
        }
      }
      if (validazione === "required" && (vm.info[chiave] === '' || vm.info[chiave] === null)) {
        vm.errors[chiave] = label + vm.$root.trans.valore_richiesto;
        b = true;
      }
      if (validazione === "required" && (vm.info[chiave] === 0 || vm.info[chiave] === undefined) && tipo === "number") {
        vm.errors[chiave] = label + vm.$root.trans.valore_richiesto;
        b = true;
      }
      if (validazione === "required" && vm.info[chiave] < '1' && tipo === "select2") {
        vm.errors[chiave] = label + vm.$root.trans.valore_richiesto;
        b = true;
      }
      if (validazione === "required" && vm.info[chiave] < '1' && tipo === "select") {
        vm.errors[chiave] = label + vm.$root.trans.valore_richiesto;
        b = true;
      }
      if (validazione === "required" && vm.info[chiave] < '1' && tipo === "select-on-change") {
        vm.errors[chiave] = label + vm.$root.trans.valore_richiesto;
        b = true;
      }
      if (validazione === "required" && vm.info[chiave] < '1' && tipo === "select-add") {
        vm.errors[chiave] = label + vm.$root.trans.valore_richiesto;
        b = true;
      }
      if (validazione === "required" && (vm.info[chiave] === 0 || vm.info[chiave] == null || vm.info[chiave] === undefined || vm.info[chiave].length === 0) && tipo === "select-multipla") {
        vm.errors[chiave] = label + vm.$root.trans.valore_richiesto;
        b = true;
      }
      if (validazione === 'bef_or_equ_today' && (tipo === "date" || tipo === "datetime")) {
        if (vm.info[chiave] !== null && vm.info[chiave] !== '') {
          const d1 = vm.createDateFromString(vm.info[chiave]);
          if (new Date(d1).getTime() <= new Date().getTime()) {
            vm.errors[chiave] = label + vm.$root.trans.bef_or_equ_today;
            b = true;
          }
        }
      }

      if (validazione === 'before_or_equal' && (tipo === "date" || tipo === "datetime")) {
        if (vm.info[chiave] !== null && vm.info[chiave] !== '' && vm.info[chiave_confronto] !== null && vm.info[chiave_confronto] !== '') {
          const d1 = vm.createDateFromString(vm.info[chiave]);
          const d2 = vm.createDateFromString(vm.info[chiave_confronto]);
          if ((new Date(d1).getTime() < new Date(d2).getTime()) || (d1 == d2)) {
            vm.errors[chiave] = label + vm.$root.trans.before_or_equal + vm.label[chiave_confronto][0];
            b = true;
          }
        }
      }
      if (validazione === 'before' && (tipo === "date" || tipo === "datetime")) {
        if (vm.info[chiave] !== null && vm.info[chiave] !== '' && vm.info[chiave_confronto] !== null && vm.info[chiave_confronto] !== '') {
          const d1 = vm.createDateFromString(vm.info[chiave]);
          const d2 = vm.createDateFromString(vm.info[chiave_confronto]);
          if (new Date(d1).getTime() > new Date(d2).getTime()) {
            vm.errors[chiave] = label + vm.$root.trans.before + vm.label[chiave_confronto][0];
            b = true;
          }
        }
      }
      if (validazione === 'after' && (tipo === "date" || tipo === "datetime")) {
        if (vm.info[chiave] !== null && vm.info[chiave] !== '' && vm.info[chiave_confronto] !== null && vm.info[chiave_confronto] !== '') {
          const d1 = vm.createDateFromString(vm.info[chiave]);
          const d2 = vm.createDateFromString(vm.info[chiave_confronto]);
          if (new Date(d1).getTime() < new Date(d2).getTime()) {
            vm.errors[chiave] = label + vm.$root.trans.before + vm.label[chiave_confronto][0];
            b = true;
          }
        }
      }
      if (validazione === 'after_or_equal' && (tipo === "date" || tipo === "datetime")) {
        if (vm.info[chiave] !== null && vm.info[chiave] !== '' && vm.info[chiave_confronto] !== null && vm.info[chiave_confronto] !== '') {
          const d1 = vm.createDateFromString(vm.info[chiave]);
          const d2 = vm.createDateFromString(vm.info[chiave_confronto]);
          if (new Date(d1).getTime() < new Date(d2).getTime() || (d1 == d2)) {
            vm.errors[chiave] = label + vm.$root.trans.before + vm.label[chiave_confronto][0];
            b = true;
          }
        }
      }
      if (validazione === 'bef_today' && (tipo === "date" || tipo === "datetime")) {
        const d1 = vm.createDateFromString(vm.info[chiave]);
        if (vm.info[chiave] !== null && vm.info[chiave] !== '') {
          if (new Date(d1).getTime() <= new Date().getTime()) {
            vm.errors[chiave] = label + vm.$root.trans.bef_today;
            b = true;
          }
        }
      }
      if (validazione === 'string_equals') {
        if (vm.info[chiave] != vm.info[chiave_confronto]) {
          vm.errors[chiave] = label + vm.$root.trans.string_equals + vm.label[chiave_confronto][0];
          b = true;
        }
      }

      if (validazione === 'onFileUpload') {
        if ((vm.info[chiave] == null || vm.info[chiave] === '') && vm.isFieldRequired(chiave)) {
          vm.errors[chiave] = label + vm.$root.trans.valore_richiesto;
          b = true;
        }
      }
      if (validazione === "required" && (vm.info[chiave] === 0 || vm.info[chiave] == null || vm.info[chiave] === undefined || vm.info[chiave].length === 0) && tipo === "select-multipla-on-change") {
        vm.errors[chiave] = label + vm.$root.trans.valore_richiesto;
        b = true;
      }

      return b;
    },
    createDateFromString(dateString) {
      // Dividi la stringa in giorno, mese e anno
      if (typeof dateString === 'string') {
        const [day, month, year] = dateString.split('-').map(Number);
        // Crea un oggetto Date (il mese è 0-based, quindi sottrai 1)
        console.log(year + "," + month - 1 + "," + day)
        console.log(new Date(year, month - 1, day))
        return new Date(year, month - 1, day);

      } else {
        return dateString;
      }

    },
    onChangeSelectMultiple: function (event, key) {
      this.onChangeSelect(event, key);

      const fieldConfig = this.label[key];
      if (fieldConfig && fieldConfig[2] && fieldConfig[2].includes('requiredselect')) {
        this.validateRequiredSelectGroup();
      }
    },
    validateRequiredSelectGroup() {
      const vm = this;
      const requiredSelectFields = [];
      for (const [key, value] of Object.entries(vm.label)) {
        if (value[2] && value[2].includes('requiredselect')) {
          requiredSelectFields.push(key);
        }
      }
      const hasAtLeastOneValue = requiredSelectFields.some(key => {
        const value = vm.info[key];
        return value && (!Array.isArray(value) || value.length > 0);
      });

      if (hasAtLeastOneValue) {
        requiredSelectFields.forEach(key => {
          delete vm.errors[key];
        });
        vm.$forceUpdate();
      }
    },
    checkForm: async function (tipo) {
      // tipo == 0 ->salva
      // tipo == 1 -> salvaecontinua
      // tipo == 2 -> apri accordion successivo
      // tipo == 3 -> form per le quali serve solo il controllo dei dati e l'invio al server viene gestito diversamente
      var vm = this;
      var b = false;

      if (tipo < 3) {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
      }

      if (this.recaptcha) {
        await this.$recaptchaLoaded()
        const token = await this.$recaptcha('ticket')
        vm.info['g_token'] = token
        document.getElementsByName('g_token')[0].value = token
        //return
      }
      for (const [key, value] of Object.entries(vm.label)) {
        if (typeof value[2] != "undefined" && value[2] !== "") {
          if (value[2].includes('|') === false) {
            if (value[2].includes(':')) {
              var key_c = value[2].split(":");
              if (vm.inputValidation(key, key_c[1], key_c[0], value[1], value[0])) {
                b = true;
              }
            } else {
              if (vm.inputValidation(key, null, value[2], value[1], value[0])) {
                b = true;
              }
            }
          } else {
            var array_validazioni = value[2].split("|");
            array_validazioni.forEach((index) => {
              if (index.includes(':')) {
                var key_c = index.split(":");
                if (vm.inputValidation(key, key_c[1], key_c[0], value[1], value[0])) {
                  b = true;
                }
              } else {
                if (vm.inputValidation(key, null, index, value[1], value[0])) {
                  b = true;
                }
              }
            });
          }
        }
      }
      if (tipo < 3) {
        if (!b) {
          vm.sendForm(tipo)
        } else {
          vm.isSubmitting = false;
        }
      } else {
        return b;
      }
    },
    checkModale: function (key, is_multi_select = false) {
      console.log(this.$refs['modalinput_' + key]);

      var vm = this.$refs['modalinput_' + key][0];
      var vm_father = this;
      var b = false;

      for (const [key, value] of Object.entries(vm.label)) {
        if (typeof value[2] != "undefined" && value[2] !== "") {
          if (value[2].includes('|') === false) {
            if (value[2].includes(':')) {
              var key_c = index.split(":");
              if (vm.inputValidation(key, key_c[1], key_c[0], value[1], value[0])) {
                b = true;
              }
            } else {
              if (vm.inputValidation(key, null, value[2], value[1], value[0])) {
                b = true;
              }
            }
          } else {
            var array_validazioni = value[2].split("|");
            array_validazioni.forEach((index) => {
              if (index.includes(':')) {
                var key_c = index.split(":");
                if (vm.inputValidation(key, key_c[1], key_c[0], value[1], value[0])) {
                  b = true;
                }
              } else {
                if (vm.inputValidation(key, null, index, value[1], value[0])) {
                  b = true;
                }
              }
            });
          }
        }
      }

      if (!b) {
        try {
          axios.post(vm.action, vm.info)
              .then(function (response) {
                if (response.data.success) {
                  vm_father.label[key][3].push(response.data.value);
                  if (!is_multi_select) {
                    vm_father.info[key] = response.data.value.id;
                  } else {
                    vm_father.info[key].push(response.data.value.id)
                  }

                  vm_father.showModal[key] = false
                } else {
                  this.$toast.add({
                    severity: 'errors',
                    summary: this.$root.trans.errors_form,
                    detail: this.$root.trans.salvataggio_errato,
                    life: 3000
                  });
                }
              }.bind(this));
        } catch (error) {
          if (error.response && error.response.status === 401) {
            this.$toast.add({
              severity: 'errors',
              summary: this.$root.trans.errors_form,
              detail: this.$root.trans.salvataggio_errato,
              life: 3000
            });
          }
        }
      }
    },
    hasFilesToSave() {
      for (const [key, value] of Object.entries(this.label)) {
        if (value[1] === 'file' && this.info[key] && this.info[key].length > 0) {
          const hasRealFiles = this.info[key].some(file =>
              file instanceof File || (file && !file.isDbFile)
          );
          if (hasRealFiles) {
            return true;
          }
        }
      }
      return false;
    },
    sendForm(tipo) { //tipo == 0 ->salva , tipo == 1 -> salvaecontinua
      var vm = this;
      console.log(vm.info)
      console.log(vm.action)
      vm.info['_token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      this.collectDatatableData();
      try {
        console.log(vm.info);
        axios.post(vm.action, vm.info, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
            .then(function (response) {
              if (response.data.success) {
                this.$toast.add({
                  severity: 'success',
                  summary: this.$root.trans.success_form,
                  detail: this.$root.trans.salvataggio_success,
                  life: 3000
                });
                const hasFiles = this.hasFilesToSave();
                if (tipo == 1) {
                  /*GESTIONE SALVA E CONTINUA verificare che sia corretto per tutti i casi*/
                  Object.keys(vm.info).forEach(key => {
                    if (Array.isArray(vm.info[key])) {
                      vm.info[key] = []; // Set arrays to empty
                    } else if (typeof vm.info[key] === "number") {
                      vm.info[key] = 0; // Set numbers to 0
                    } else {
                      vm.info[key] = ""; // Set everything else to empty string
                    }
                  });
                } else if (tipo == 0) {
                  if (response.data.redirect) {
                    if (response.data.redirect_url) {
                      window.location.href = response.data.redirect_url;
                    } else if (response.data.params) {
                      window.location.href = route(response.data.redirect, response.data.params);
                    } else {
                      window.location.href = route(response.data.redirect);
                    }
                  } else {
                    document.dispatchEvent(new CustomEvent('form-saved-success'));
                  }
                }
              } else {
                vm.isSubmitting = false;
                vm.$emit('submit-error');
                if (response.data.error != null) {
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$root.trans.errors_form,
                    detail: response.data.error,
                    life: 5000
                  });
                } else if (response.data.message != null) {
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$root.trans.errors_form,
                    detail: this.$root.trans[response.data.message],
                    life: 5000
                  });
                } else {
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$root.trans.errors_form,
                    detail: this.$root.trans.salvataggio_errato,
                    life: 3000
                  });
                }
              }
            }.bind(this))
            .catch(function (error) {
              vm.isSubmitting = false;
              vm.$emit('submit-error');
              if (error.response) {
                const payload = error.response.data || {};
                const detail = payload.error
                    ? payload.error
                    : (payload.message ? (this.$root.trans[payload.message] || payload.message) : this.$root.trans.salvataggio_errato);
                try {
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$root.trans.errors_form,
                    detail,
                    life: 5000
                  });
                } catch (e) {
                }
              } else {
                try {
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$root.trans.errors_form,
                    detail: this.$root.trans.salvataggio_errato,
                    life: 3000
                  });
                } catch (e) {
                }
              }
            }.bind(this));
      } catch (error) {
        // noop: axios handles errors in catch above
      }
    },
  }
}
</script>
